import dhtmlXTabBar from './dhtmlXTabBar';
//获取tabset对应的url映射路径
dhtmlXTabBar.prototype.getUrlMapping = function(id) {
    if(this.urlMaping == null) {
        this.urlMaping = {};
    }
    return this.urlMaping[id];
};
//添加tabset的url映射路径
dhtmlXTabBar.prototype.addUrlMapping = function(id, url) {
    if(this.urlMaping == null) {
        this.urlMaping = {};
    }
    this.urlMaping[id] = url;
};
//隐藏url映射
dhtmlXTabBar.prototype.removeUrlMapping = function(id) {
    if(this.urlMaping == null) {
        this.urlMaping = {};
    }
    this.urlMaping[id] = null;
};
//删除tab页
dhtmlXTabBar.prototype.removeTab = function(routerId) {
    // $("#"+routerId).html("");
    $("#" + routerId).appendTo(".content-frame");
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTabBar/dhtmlXTabBarExtend.js